export const PRODUCT_NAME = 'Sophie Assist';
const publicRoot = process.env.PUBLIC_URL || '';
export const brandAssets = {
  logo: `${publicRoot}/branding/sophie-assist-logo.svg`,
  icon: `${publicRoot}/branding/sophie-assist-icon.svg`,
};
